var cilMediaStop = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M408,80H104a24.027,24.027,0,0,0-24,24V408a24.027,24.027,0,0,0,24,24H408a24.027,24.027,0,0,0,24-24V104A24.027,24.027,0,0,0,408,80Zm-8,320H112V112H400Z' class='ci-primary'/>"];

export { cilMediaStop };

